<template>
  <v-row justify="end">
    <v-dialog v-model="dialog" persistent max-width="1050px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small v-bind="attrs" v-on="on">
          <v-icon color="primary">mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-form ref="form" v-model="validForm" lazy-validation>
        <v-card>
          <div class="padding-card">
            <p class="title-modal">Editar Tipo Egreso</p>
            <EditSpendType ref="editSpendType" :tipo="tipo" @savetype="save"/>
          </div>
          <v-card-actions>
            <!-- <v-btn :disabled="!validForm" @click="validate" depressed color="#00aff2" dark> Guardar usuario </v-btn> -->
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false"> Cerrar </v-btn>
          
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>

import EditSpendType from './EditSpendType.vue';
import adminSuppliersService from '@/services/admin/supplierPayments';

export default {
  name: 'ModalUser',
  components: {
    EditSpendType,
  },
  props: {
    tipo: {
      type: Object,
      required: true,
  }},
  data: () => ({
    validForm: true,
    dialog: false,
    readyToSave: false,
  }),

  methods: {
    close() {
      this.dialog = false;
      this.$refs.formEditSpendType.reset();
    },
    save(data) {        
      adminSuppliersService
        .editSpendType(data.id, data)
        .then(() => {
          this.name = '';
          this.$swal('Tipo de egreso', 'Cambio exitoso', 'success');
          this.dialog = false;
          this.$emit('getPaymentTypes');
        })
        .catch((error) => {
          if (error.response && error.response.status === 400) {
            this.$swal('Error al cambiar el tipo de egreso', error.response.data.message, 'warning');
          }  else if (error.response && error.response.status === 409) {
            this.$swal('Error. El tipo de egreso puede estar duplicado', error.response.data.message, 'warning');                 
          } else {
            this.$swal('Error al registrar el Tipo de Egreso', error.response.data.message, 'warning');
          }
          this.dialog = false;
      });
    },    
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>